"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var config = {
  angConfiguration: {
    typeURL: 'http://anypoint.com/vocabs/digital-repository#ExternalLibraryAsset',
    assetType: 'ExternalLibrary'
  },
  owner: {
    gusTeam: 'MS Exchange Catalog',
    gusTeamLink: 'https://gus.lightning.force.com/lightning/r/ADM_Scrum_Team__c/a00AH000000in0tYAA/view'
  },
  name: 'External Library',
  pluralName: 'External Libraries',
  publication: {
    inferredBy: [{
      classifiers: ['external-library']
    }],
    files: [{
      id: 'lib',
      classifier: 'external-library',
      packaging: 'jar'
    }],
    minimumInputSets: [{
      files: ['lib']
    }]
  }
};
var _default = exports.default = config;
//# sourceMappingURL=config.js.map